import Home from "../Components/Home";
import Insights from "../Components/Insights/Insights";

const Routes = {
  "/": () => <Home />,
  "/insights": () => <Insights />,
};

export default Routes;
